// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__1P5oQ","cardSubTitle":"styles_cardSubTitle__ZYIi8"};